import type { ArgusSessionResponse, ArgusSessionsListResponse } from "../../types/argus";
import { useApiQuery } from "../use-api-query";

interface UseArgusSessionsOptions {
  limit?: number;
  offset?: number;
}

export function useArgusSessions(
  instanceId: string | undefined,
  options: UseArgusSessionsOptions = {},
) {
  const { limit = 20, offset = 0 } = options;

  const params = new URLSearchParams();
  params.set("limit", String(limit));
  params.set("offset", String(offset));

  const query = useApiQuery<ArgusSessionsListResponse>(
    `/client/argus/instances/${instanceId}/sessions?${params.toString()}`,
    { enabled: !!instanceId },
  );

  return {
    ...query,
    sessions: query.data?.data?.sessions as ArgusSessionResponse[] | undefined,
    total: query.data?.data?.total,
  };
}
